export const apiUrl = "https://flames01api.WaEPOS.com/";
export const adminUrl = "https://flames01admin.WaEPOS.com/";
